<template>
  <div class="ele-body">
    <el-card shadow="never" v-loading="loading" body-style="padding-bottom: 0;">
      <el-row :gutter="15">
        <el-col :md="5" style="margin-bottom: 10px">
          <!-- 操作按钮 -->
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="addDormitory" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small" :disabled="current.orgType === 4"
              >添加
            </el-button>
            <el-button @click="editDormitory" type="warning" icon="el-icon-edit" class="ele-btn-icon" :disabled="!current" size="small"
              >修改
            </el-button>
            <el-button @click="removeDormitory" type="danger" icon="el-icon-delete" class="ele-btn-icon" :disabled="!current" size="small"
              >删除
            </el-button>
          </div>
          <div class="ele-table-tool-default" v-if="current.orgType === 3">
            <el-input v-model="star" class="class" />
            至
            <el-input v-model="end" class="class" />
            <el-button @click="batchAddOrg" type="primary" class="ele-btn-icon" size="small" style="margin-left: 10px">批量建立宿舍</el-button>
          </div>
          <!-- 区域列表 -->
          <div class="org-tree-group">
            <el-tree
              ref="dorTree"
              :data="dormitoryData"
              :props="{ label: 'name' }"
              :expand-on-click-node="false"
              node-key="id"
              :default-expanded-keys="dataIdArr"
              @node-click="choose"
              highlight-current
            />
          </div>
        </el-col>
        <el-col :md="19" style="margin-bottom: 10px">
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="distribution" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">分配学生 </el-button>
            <el-button @click="distributionTea" type="warning" icon="el-icon-plus" class="ele-btn-icon" size="small">分配教师 </el-button>
            <el-button @click="removeStudent()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small">删除 </el-button>
            <el-button @click="showImport = true" icon="el-icon-upload2" class="ele-btn-icon" size="small">学生分配批量导入</el-button>
            <el-button @click="showSearch = true" icon="el-icon-search" class="ele-btn-icon" size="small">学生宿舍查询</el-button>
          </div>
          <!-- 数据表格 -->
          <ele-data-table
            ref="table"
            :config="table"
            :row-key="getRowKey"
            :choose.sync="chooseStudent"
            height="calc(100vh - 215px)"
            highlight-current-row
          >
            <template #default="{ index }">
              <el-table-column type="selection" width="45" align="center" fixed="left" :reserve-selection="true" />
              <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
              <el-table-column prop="student_name" label="姓名" show-overflow-tooltip min-width="110" />
              <el-table-column label="类别" show-overflow-tooltip min-width="110">
                <template #default="scope">
                  <span v-if="scope.row.type == 0">学生</span>
                  <span v-else>老师</span>
                </template>
              </el-table-column>
              <el-table-column prop="branch_name" label="部系" show-overflow-tooltip />
              <el-table-column prop="grade_name" label="年级" show-overflow-tooltip />
              <el-table-column prop="class_name" label="班级" show-overflow-tooltip />
              <el-table-column prop="bed_number" label="床位号" show-overflow-tooltip />
              <el-table-column label="操作" width="180px" align="center" :resizable="false">
                <template #default="{ row }">
                  <el-link @click="openBed(row)" icon="el-icon-ship" type="primary" :underline="false">设置床位</el-link>
                  <el-popconfirm title="确定要移除此学生吗？" @onConfirm="removeStudent(row)" class="ele-action">
                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">移除</el-link>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </template>
          </ele-data-table>
        </el-col>
      </el-row>
    </el-card>
    <!--编辑弹窗-->
    <el-dialog
      :title="editForm.id ? '修改宿舍结构' : '添加宿舍结构'"
      :visible.sync="showEdit"
      width="600px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="82px">
        <el-row :gutter="15">
          <el-col :sm="12">
            <el-form-item label="上级组织:" prop="parentId">
              <treeselect
                v-model="editForm.parentId"
                :options="dormitoryList"
                placeholder="请选择所属区域"
                :defaultExpandLevel="4"
                :normalizer="
                  (d) => {
                    return { id: d.id, label: d.name };
                  }
                "
              />
            </el-form-item>
            <el-form-item label="名称:" prop="name">
              <el-input v-model="editForm.name" placeholder="请输入名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="类型:" prop="orgType">
              <el-select v-model="editForm.orgType" placeholder="请选择学校类型" class="ele-block" clearable>
                <el-option label="宿舍楼" :value="2" />
                <el-option label="楼层" :value="3" />
                <el-option label="宿舍号" :value="4" />
              </el-select>
            </el-form-item>
            <el-form-item label="排序号:" prop="orderNum">
              <el-input v-model="editForm.orderNum" placeholder="请输入序号" clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="saveOrg(editForm.id)">保存</el-button>
      </div>
    </el-dialog>
    <!-- 分配学生编辑弹窗 -->
    <el-dialog
      title="分配学生"
      :visible.sync="showDistribution"
      width="400px"
      @closed="distributionForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <div class="dialog-height">
        <el-form :model="distributionForm" ref="editForm" label-width="85px">
          <el-row :gutter="15">
            <el-col>
              <el-input placeholder="输入关键字进行过滤" v-model="filterText" />
              <el-tree
                ref="studentTree"
                :model="distributionForm.studentIds"
                :data="studentList"
                :default-expanded-keys="dataIdArr"
                :props="{ label: 'name' }"
                node-key="id"
                show-checkbox
                highlight-current
                :default-checked-keys="Checked"
                :filter-node-method="filterNode"
              />
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="showDistribution = false">取消</el-button>
        <el-button type="primary" @click="saveStudent">保存</el-button>
      </div>
    </el-dialog>
    <!--分配教师-->
    <el-dialog
      title="分配教师"
      :visible.sync="showDistributionTea"
      width="400px"
      @closed="distributionFormTea = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <div class="dialog-height">
        <el-form :model="distributionFormTea" ref="editFormTea" label-width="85px">
          <el-row :gutter="15">
            <el-col>
              <el-input placeholder="输入关键字进行过滤" v-model="filterTextTea" />
              <el-tree
                ref="teacherTree"
                :model="distributionFormTea.teacherIds"
                :data="deptTeacher"
                :default-expanded-keys="dataIdArrTea"
                :props="{ label: 'name' }"
                node-key="id"
                show-checkbox
                :expand-on-click-node="true"
                highlight-current
                accordion
                :filter-node-method="filterNodeTea"
              />
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="showDistributionTea = false">取消</el-button>
        <el-button type="primary" @click="saveTeacher">保存</el-button>
      </div>
    </el-dialog>
    <!-- 用户导入弹窗 -->
    <el-dialog title="批量分配宿舍" :visible.sync="showImport" width="440px" :destroy-on-close="true" :lock-scroll="false">
      <el-upload
        v-loading="uploadLoading"
        :action="$http.defaults.baseURL + '/school/dormitory/batchStudentAssignedDormitoryRoom'"
        accept=".xls,.xlsx"
        :headers="$http.defaults.headers.common"
        :before-upload="() => (uploadLoading = true)"
        class="ele-block"
        :on-success="uploadInfoSuccess"
        :on-error="() => (uploadLoading = false)"
        :show-file-list="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或 <em>点击上传</em></div>
        <div class="el-upload__tip ele-text-center" slot="tip">
          只能上传xls、xlsx文件，
          <el-link type="primary" :underline="false" :href="importTplUrl" download style="vertical-align: baseline">下载模板 </el-link>
        </div>
      </el-upload>
    </el-dialog>
    <!-- 设置床位 -->
    <el-dialog
      title="设置床位号"
      :visible.sync="showBed"
      width="400px"
      @closed="bedNum = null"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <div style="display: flex; align-items: center; margin-bottom: 20px">
        <div>床位号：</div>
        <div style="margin-left: 5px">
          <el-input-number v-model="bedNum" :min="0" />
        </div>
      </div>
      <div slot="footer">
        <el-button @click="showBed = false">取消</el-button>
        <el-button type="primary" @click="saveBed">保存</el-button>
      </div>
    </el-dialog>
    <!--学生宿舍查询-->
    <el-dialog
      title="学生宿舍查询"
      :visible.sync="showSearch"
      width="400px"
      @closed="dorStudentName = null,searchList=[]"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false">
      <div style="display: flex; align-items: center; margin-bottom: 20px">
        <div>学生姓名：</div>
        <div style="margin-left: 5px">
          <el-input v-model="dorStudentName" placeholder="请输入学生姓名"/>
        </div>
      </div>
      <div v-if='searchList.length != 0'>
        <div style='font-size: 16px;font-weight: bolder'>宿舍信息：</div>
        <div v-for='(item,index) in searchList' v-key='index'>
          <div>{{item.studentData}}</div>
          <div>{{item.dormitoryData}}</div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="showSearch = false">取消</el-button>
        <el-button type="primary" @click="searchStudent">查询</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getDormitoryStructureTree,
    addDormitoryStructure,
    updateDormitoryStructure,
    deleteDormitoryStructure,
    studentRemoveDormitoryRoom,
    getStudentTreeByDormitoryState,
    studentAssignedDormitoryRoom,
    batchAddDormitoryRoom,
    getAllDepartTeachers,
    teacherAssignedDormitoryRoom,
    updateBedNumberById,
    getStudentDormitoryRoomData,
    // finiteDataTree
  } from '@/config/api';
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';

  export default {
    name: 'Index',
    components: { Treeselect },
    data() {
      return {
        loading: false,
        dormitoryData: null,
        dormitoryList: [],
        current: null,
        showEdit: false, // 是否显示表单弹窗
        editForm: {
          name: '',
          orderNum: '',
          parentId: '',
          orgType: '',
        }, // 表单数据
        editRules: {
          // 表单验证规则
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          orderNum: [{ required: true, message: '请输入排序号', trigger: 'blur' }],
          parentId: [{ required: true, message: '请选择上级部门', trigger: 'change' }],
          orgType: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        },
        table: {
          url: '/school/dormitory/getStudentsByDormitoryRoom',
          method: 'GET',
          where: {
            roomId: '',
          },
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        getRowKey(row) {
          return row.id;
        },
        showDistribution: false,
        distributionForm: {},
        studentList: [], //学生树列表
        chooseStudent: [], //选中学生数据
        studentIds: [],
        dataIdArr: [],
        star: null,
        end: null,
        filterText: '', //关键字
        showImport: false,
        uploadLoading: false,
        importTplUrl: 'https://hdsys.oss-cn-beijing.aliyuncs.com/hdjxt/template/1634172928337/学生分配宿舍.xlsx', // 导入模板下载地址
        deptTeacher: [],
        teacherIds: [],
        showDistributionTea: false,
        distributionFormTea: {},
        filterTextTea: '', //关键字
        dataIdArrTea: [],
        showBed: false,
        bedNum: null,
        bedId: null,
        showSearch: false,
        dorStudentName: null,
        searchList: []
      };
    },
    computed: {
      Checked() {
        let checked = [];
        this.$util.eachTreeData(this.studentList, (d) => {
          if (d.checked && (!d.children || !d.children.length)) checked.push(d.id);
        });
        return checked;
      },
    },
    watch: {
      filterText(val) {
        this.$refs.studentTree.filter(val);
      },
      filterTextTea(val) {
        this.$refs.teacherTree.filter(val);
      },
    },
    mounted() {
      this.queryDor();
    },
    methods: {
      // 获取宿舍结构
      queryDor() {
        getDormitoryStructureTree().then((res) => {
          if (res.data.resCode == 200) {
            this.dormitoryData = res.data.data;
            this.dormitoryList = res.data.data;
            this.$util.eachTreeData(this.dormitoryList, (d) => {
              if (!d.children || !d.children.length) delete d.children;
            });
            this.dataIdArr = this.$util.getTreeFloor(this.dormitoryData, 1, this.dataIdArr, 'id');
            setTimeout(() => {
              this.choose(this.dormitoryData[0]);
            }, 100);
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      //选择数据
      choose(row) {
        if (row != null) {
          this.current = row;
          this.$nextTick(function() {
            this.$refs.dorTree.setCurrentNode(row);
          });
          if (row.orgType == 4) {
            this.table.where.roomId = row.id.slice(1);
            this.$refs.table.reload();
          }
          // else {
          //   this.$message.info('请选择宿舍房间');
          // }
        } else {
          this.current = null;
        }
      },
      // 添加宿舍结构窗口
      addDormitory() {
        this.editForm.parentId = this.current.id;
        if (this.current.orgType != undefined) {
          this.editForm.orgType = this.current.orgType + 1;
        }
        this.showEdit = true;
      },
      /* 显示编辑 */
      editDormitory() {
        this.editForm = Object.assign({}, this.current, {
          parentId: this.current.parentId || null,
        });
        this.showEdit = true;
      },
      // 保存宿舍结构
      saveOrg(orgId) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (orgId == undefined) {
              //添加角色
              formData.set('dataType', this.editForm.orgType);
              formData.set('parentId', this.editForm.parentId.slice(1));
              addDormitoryStructure(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.showEdit = false;
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.queryDor();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            } else {
              //编辑角色
              formData.set('id', this.editForm.id.slice(1));
              formData.set('dataType', this.editForm.orgType);
              formData.set('parentId', this.editForm.parentId.slice(1));
              updateDormitoryStructure(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.showEdit = false;
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.queryDor();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            }
          } else {
            return false;
          }
        });
      },
      // 删除宿舍
      removeDormitory() {
        this.$confirm('确定要删除选中的机构吗?', '提示', {
          type: 'warning',
        }).then(() => {
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('dataType', this.current.orgType);
          formData.append('id', this.current.id.slice(1));
          deleteDormitoryStructure(formData).then((res) => {
            loading.close();
            // console.log(res);
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.queryDor();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
      //批量建立宿舍
      batchAddOrg() {
        let data = new FormData();
        data.append('star', this.star);
        data.append('end', this.end);
        data.append('storeyId', this.current.id.slice(1));
        batchAddDormitoryRoom(data).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.queryDor();
          }
        });
      },
      // 分配学生窗口
      distribution() {
        if (this.current.orgType == 4) {
          if (this.table.where.roomId) {
            this.showDistribution = true;
            let data = {
              roomId: this.table.where.roomId,
            };
            // 获取学生班级树
            getStudentTreeByDormitoryState(data).then((res) => {
              if (res.data.resCode == 200) {
                this.studentList = res.data.data;
                //默认展开树的层数
                this.dataIdArr = this.$util.getTreeFloor(this.studentList, 2, this.dataIdArr, 'id');
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          }
        } else {
          this.$message.info('请选择左侧宿舍房间');
        }
      },
      // 分配教师窗口
      distributionTea() {
        if (this.current.orgType == 4) {
          if (this.table.where.roomId) {
            this.showDistributionTea = true;
            getAllDepartTeachers().then((res) => {
              if (res.data.resCode == 200) {
                this.deptTeacher = res.data.data;
                //默认展开树的层数
                this.dataIdArrTea = this.$util.getTreeFloor(this.deptTeacher, 2, this.dataIdArrTea, 'id');
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          }
        } else {
          this.$message.info('请选择左侧宿舍房间');
        }
      },
      // 获取学生id
      getNodeStudentIds(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].orgType == 5) {
            this.studentIds.push(data[i].id.slice(1));
          }
        }
      },
      // 保存宿舍分配
      saveStudent() {
        let studentIds = this.$refs.studentTree.getCheckedNodes();
        this.getNodeStudentIds(studentIds);
        let formData = new FormData();
        formData.append('studentIds', this.studentIds);
        formData.append('roomId', this.table.where.roomId);
        studentAssignedDormitoryRoom(formData).then((res) => {
          if (res.data.resCode == 200) {
            this.showDistribution = false;
            this.$message({ type: 'success', message: '分配成功' });
            this.studentIds = [];
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 移除学生
      removeStudent(row) {
        if (!row) {
          //批量
          if (this.chooseStudent.length === 0) return this.$message.error('请至少选择一条数据');
          let ids = this.chooseStudent.map((d) => d.id);
          this.$confirm('确定要移除选中的学生吗?', '提示', {
            type: 'warning',
          }).then(() => {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            formData.append('studentIds', ids);
            formData.append('roomId', this.table.where.roomId);
            studentRemoveDormitoryRoom(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          });
        } else {
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('studentIds', row.id);
          formData.append('roomId', this.table.where.roomId);
          studentRemoveDormitoryRoom(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        }
      },
      // 获取教师id
      getNodeTeacherIds(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].type == 2) {
            this.teacherIds.push(data[i].id);
          }
        }
        this.teacherIds = [...new Set(this.teacherIds)]; //js去重
      },
      // 保存分配老师
      saveTeacher() {
        let teacherIds = this.$refs.teacherTree.getCheckedNodes();
        this.getNodeTeacherIds(teacherIds);
        let formData = new FormData();
        formData.append('teacherIds', this.teacherIds);
        formData.append('roomId', this.table.where.roomId);
        teacherAssignedDormitoryRoom(formData).then((res) => {
          if (res.data.resCode == 200) {
            this.showDistributionTea = false;
            this.$message({ type: 'success', message: '分配成功' });
            this.teacherIds = [];
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 根据关键字筛选
      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
      // 根据关键字筛选
      filterNodeTea(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
      // 导入宿舍分配
      uploadInfoSuccess(res) {
        this.uploadLoading = false;
        // console.log(res);
        if (res.resCode == '200') {
          this.showImport = false;
          this.$message({
            type: 'success',
            showClose: true,
            message: res.resMsg,
            duration: 0,
          });
          this.$refs.table.reload();
        } else if (res.resCode == '5001') {
          const url = res.resMsg;
          this.$confirm('是否下载本次导入失败的记录', '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              window.open(url);
              this.showImport = false;
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '下载失败',
              });
              this.showImport = false;
            });
        } else {
          this.$message.error(res.resMsg);
        }
      },
      // 打开设置床位弹窗
      openBed(row) {
        this.bedNum = row.bed_number;
        this.bedId = row.id;
        this.showBed = true;
      },
      // 保存床位号
      saveBed() {
        let formdata = new FormData();
        formdata.append('id', this.bedId);
        formdata.append('bedNum', this.bedNum);
        updateBedNumberById(formdata).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '分配成功' });
            this.$refs.table.reload();
            this.showBed = false;
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 查询学生
      searchStudent(){
        getStudentDormitoryRoomData({studentName: this.dorStudentName}).then((res) =>{
          if(res.data.resCode == 200){
            this.searchList = res.data.data
          }
        })
      }
    },
  };
</script>

<style scoped>
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 210px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 30px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
  /deep/ .el-tree .el-tree-node .is-leaf + .el-checkbox .el-checkbox__inner {
    display: inline-block;
  }
  /deep/ .el-tree .el-tree-node .el-checkbox .el-checkbox__inner {
    display: none;
  }
  .dialog-height {
    height: 60vh;
    overflow-x: hidden;
  }
  .class {
    width: 20%;
  }
  .ele-block {
    display: flex !important;
    flex-flow: column !important;
    align-items: center !important;
  }
</style>
